var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.applicantInfoData)?_c('div',{staticClass:"content"},[_c('applicant-info'),_c('round-info',{attrs:{"slug":this.$route.params.slug}}),_c('comments-section'),_c('follow-up-status'),(
      _vm.hasAccess({
        permissions: [_vm.PERMISSIONS.MAIL.MENU],
        checkAll: false,
      })
    )?_c('email-conversation'):_vm._e()],1):_c('div',{staticClass:"not-found-container"},[_c('h4',{staticClass:"not-found pt-0"},[_vm._v("Applicant Not Found")]),_c('button',{staticClass:"btn btn-cp mt-3",attrs:{"type":"button"},on:{"click":_vm.goBack}},[_vm._v(" Go Back to Applicant List ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }